import dotProp from 'dot-prop-immutable'
import {
  FINISH_RESIZING_PRODUCT,
  PRODUCTS_ARE_LOADING,
  PRODUCTS_FAILED,
  PRODUCTS_LOADED,
  SETS_LOADED,
  START_RESIZING_PRODUCT,
} from '../constants/productsActions'

const initialState = {
  isLoading: false,
  isResizing: false,
  errMessage: '',
  images: [],
  sets: [],
}

export default function(state = initialState, action) {
  switch (action.type) {
    case PRODUCTS_ARE_LOADING:
      return dotProp.set(state, 'isLoading', true)
    case PRODUCTS_LOADED:
      state = dotProp.set(state, 'images', action.images)
      state = dotProp.set(state, 'isLoading', false)

      return state
    case SETS_LOADED:
      state = dotProp.set(state, 'sets', action.images)
      state = dotProp.set(state, 'isLoading', false)

      return state
    case PRODUCTS_FAILED:
      state = dotProp.set(state, 'isLoading', false)
      state = dotProp.set(state, 'errMessage', action.message)

      return state
    case START_RESIZING_PRODUCT:
      return dotProp.set(state, 'isResizing', action.index)
    case FINISH_RESIZING_PRODUCT:
      return dotProp.set(state, 'isResizing', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/products.js